// @ts-nocheck
import { Component, Input } from '@angular/core';

@Component({
	selector: 'lbca-loading',
	templateUrl: './loading.component.html',
})
export class LoadingComponent {
	@Input()
	position: string = 'absolute';
}
